import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Constants
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { HOME_INSURANCE_WIN } from '../../../../../constants/wins'

// Contexts
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// selectors
import { selectDaysUntilRenewal } from '../../../../../store/selectors/homeInsurance'

// Components
import { Text } from '../../../..'
import ImportantNowCard from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const HomeInsurance = () => {
  const renewDays = useSelector(selectDaysUntilRenewal)
  const { theme } = useTheme()
  const { ampli } = useContext(AmplitudeContext)

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='HomeInsurance'
      event={() => ampli?.winClicked({ win_type: HOME_INSURANCE_WIN })}
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.homeInsurance.buildPath('more-details')}
      data-qa='home-insurance-win'
    >
      <FormattedMessage
        id='ImportantNow.spotlight.homeInsurance'
        defaultMessage='Your home insurance might renew in about {bold}'
        values={{
          bold: (
            <Text element='span' weight='semibold' variant='primary'>
              {renewDays}{' '}
              <FormattedMessage
                id='ImportantNow.spotlight.homeInsurance.days'
                defaultMessage='days'
              />
            </Text>
          ),
        }}
      />
    </ImportantNowCard>
  )
}

HomeInsurance.propTypes = {}

export default HomeInsurance
